import React, { useReducer, VFC, Reducer } from 'react';
import { SnackbarProvider } from 'notistack';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PlanApiService from '../../services/PlanApiService';
import { initialState, reducer, ACTION_TYPE, State, Action } from './reducer';
import AuthDialogContextProvider from '../AuthDialog/AuthDialogContextProvider';
import HeaderComponent from './templates';
import DummyHeader from './atoms/DummyHeader';
import ScheduleSnackbar from './organisms/ScheduleSnackbar';
import SnsBanner from './organisms/SnsBanner';

import { BUSINESSES, PLANS, APP_VIEW } from '../../constants/routing';
// TODO ファイルの依存関係的に危険な匂いがするので、Snackbarコンポーネントを適切なディレクトリに配置したい
import Snackbar from '../../../../components/front/Snackbar';
import SearchDrawer from './organisms/SearchDrawer';
import useSearchForm from './hooks/useSearchForm';

const SNS_BANNER_DISPLAY_PATHS = [BUSINESSES, PLANS];
const isAppView = !window.location.pathname.includes(APP_VIEW);
const isDisplayBanner = SNS_BANNER_DISPLAY_PATHS.includes(
  window.location.pathname,
);

const planApiService = new PlanApiService();

export interface Props {
  authenticated?: boolean;
  imageUrl?: string | null;
  isWorking?: boolean;
  message?: string | string[] | null;
}
const Header: VFC<Props> = ({
  authenticated,
  isWorking,
  imageUrl,
  message,
}: Props) => {
  const [state, dispatch] = useReducer<Reducer<State, Action>>(
    reducer,
    initialState,
  );
  const {
    state: searchForm,
    handleChangeSearchForm,
    handleChangeSearchTerm,
    resetSearchForm,
    doSearch,
  } = useSearchForm();
  const theme = useTheme();
  const isPC = useMediaQuery(theme.breakpoints.up('md'));

  // アプリ内ブラウザからのアクセスの場合、ヘッダーは不要なので余計な計算をする前に早期returnする
  if (!isAppView) return null;

  // Event handlers
  const handleDrawer = (event, open) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    dispatch({
      type: ACTION_TYPE.SET_SP_DRAWER_OPEN,
      payload: { spDrawerOpen: open },
    });
  };
  const handleOpenSPDrawer = (event) => {
    handleDrawer(event, true);
  };
  const handleCloseSPDrawer = (event) => {
    handleDrawer(event, false);
  };
  const handleClickSPDrawer = (event) => {
    state.spDrawerOpen ? handleCloseSPDrawer(event) : handleOpenSPDrawer(event);
  };

  const handleOpenProfileMenu = (anchorEl: Element | null) => {
    dispatch({
      type: ACTION_TYPE.SET_PROFILE_MENU_EL,
      payload: { profileMenuEl: anchorEl },
    });
  };

  const fetchSearchChoice = () => {
    planApiService
      .fetchSearchChoice()
      .then(({ tags, regions }) => {
        dispatch({
          type: ACTION_TYPE.SET_SEARCH_CHOICE,
          payload: { loadedSearchChoice: true, tags, regions },
        });
      })
      .catch((err) => {});
  };
  const handleOpenSearchDrawer = () => {
    dispatch({
      type: ACTION_TYPE.SET_SEARCH_CHOICE,
      payload: { searchDrawerOpen: true, spDrawerOpen: false },
    });

    if (!state.loadedSearchChoice) {
      fetchSearchChoice();
    }
  };
  const handleCloseSearchDrawer = () => {
    dispatch({
      type: ACTION_TYPE.SET_SEARCH_DRAWER_OPEN,
      payload: { searchDrawerOpen: false },
    });
  };

  return (
    <SnackbarProvider>
      <AuthDialogContextProvider isLoggedIn={!!authenticated}>
        <HeaderComponent
          {...state}
          isPC={isPC}
          authenticated={!!authenticated}
          imageUrl={imageUrl}
          handleOpenSPDrawer={handleOpenSPDrawer}
          handleCloseSPDrawer={handleCloseSPDrawer}
          handleClickSPDrawer={handleClickSPDrawer}
          handleOpenSearchDrawer={handleOpenSearchDrawer}
          handleOpenProfileMenu={handleOpenProfileMenu}
        />
        <DummyHeader isPC={isPC} />
        <SearchDrawer
          open={state.searchDrawerOpen}
          searchForm={searchForm}
          regions={state.regions}
          tags={state.tags}
          onClose={handleCloseSearchDrawer}
          handleChangeSearchForm={handleChangeSearchForm}
          handleChangeSearchTerm={handleChangeSearchTerm}
          reset={resetSearchForm}
          search={doSearch}
        />
        {isDisplayBanner && !authenticated && <SnsBanner />}
        {isWorking && <ScheduleSnackbar />}
        <Snackbar message={message} options={{ variant: 'success' }} />
      </AuthDialogContextProvider>
    </SnackbarProvider>
  );
};

export default Header;
